module.exports = __webpack_public_path__ + "img/contacto.2bfd6fe9.svg";